import { Fragment, useEffect } from 'react';

import Field from '../../../form/Field';
import Form from '../../../form/Form';

import { useFilter } from './useFilter';

function Checklist(props) {
    useEffect(() => {
        const selectedOptions = props.context.getFilterValue(props.name);
        bindValues(selectedOptions);
    }, [props.options]);

    const handleClear = form => {
        if (form) {
            form.setFieldValue('options', []);
        }
        setFilterValue(props.name, null);
        setValue(null);
    };

    const handleCancel = () => {
        handleToggle();
    };

    const filter = useFilter(
        props,
        () => {
            const selectedOptions = props.context.getFilterValue(props.name);
            bindValues(selectedOptions);
        },
        handleClear
    );

    const { options = [] } = props;
    const { value, setValue, handleToggle, setFilterValue, renderMenuButtons } = filter;

    const handleSubmit = values => {
        let label = null;

        if (!values.options) {
            setValue(null);

            return;
        }

        const filterValues = [];

        values.options.forEach(option => {
            filterValues.push(option.value);
        });

        label = renderLabel(values.options);

        setValue({ value: values.options, label: label });
        setFilterValue(props.name, filterValues);
        handleToggle();
    };

    const handleCheckChange = (e, option, form, field) => {
        if (e.target.checked) {
            form.setFieldValue(field.name, [...form.values.options, option]);
        } else {
            const newOptions = [...form.values.options];
            const foundIndex = newOptions.findIndex(opt => opt.value == option.value);

            if (foundIndex >= 0) {
                newOptions.splice(foundIndex, 1);
            }
            form.setFieldValue(field.name, newOptions);
        }
    };

    const handleGroupCheckChange = (e, groupOptions, form, field) => {
        if (e.target.checked) {
            const newOptions = [...form.values.options, ...groupOptions];
            form.setFieldValue(field.name, newOptions);
        } else {
            const newOptions = form.values.options.filter(opt => {
                if (typeof opt === 'object') {
                    const isFormItemInUnselectedGroup = Array.isArray(groupOptions) && groupOptions.findIndex((go => {
                        return go.label == opt.label && go.value == opt.value;
                    })) >= 0;
                    
                    return !isFormItemInUnselectedGroup;
                }

                return !groupOptions.includes(opt);
            });
            form.setFieldValue(field.name, newOptions);
        }
    };

    const bindValues = selectedOptions => {
        if (!selectedOptions) return;
        if (selectedOptions.length == 0) return;

        if (options[0]?.options) {
            const foundOptions = options.flatMap(option => {
                if (option.options) {
                    return option.options.filter(opt => {
                        if (Array.isArray(selectedOptions)) return selectedOptions.some(so => so == opt.value);

                        return selectedOptions == opt.value;
                    });
                }
            });

            if (foundOptions) {
                setValue({ value: foundOptions, label: renderLabel(foundOptions) });
            }
        } else {
            const foundOptions = options.filter(option => {
                if (Array.isArray(selectedOptions)) return selectedOptions.find(selectedOption => selectedOption == option.value);

                return selectedOptions == option.value;
            });

            if (foundOptions) {
                setValue({ value: foundOptions, label: renderLabel(foundOptions) });
            }
        }
    };

    const renderLabel = selectedOptions => {
        if (!selectedOptions) return null;
        if (selectedOptions.length == 0) return null;

        const labelComponents = [];

        selectedOptions.forEach(option => {
            labelComponents.push(<li>{option.label}</li>);
        });

        return (
            <ul
                className="list list-commas"
                style={{
                    display: 'inline-block',
                    height: '50px !important',
                    overflow: 'scroll !important'
                }}
            >
                {labelComponents.map((item, itemIndex) => (
                    <Fragment key={itemIndex}>{item}</Fragment>
                ))}
            </ul>
        );
    };

    return filter.render(
        <div
            className="searchable-list-filter-menu"
            style={{
                padding: '10px',
                minWidth: '300px'
            }}
        >
            <Form
                enableReinitialize
                initialValues={{
                    options: value ? value.value : []
                }}
                onSubmit={handleSubmit}
                render={form => {
                    return (
                        <form onSubmit={form.handleSubmit}>
                            <Field
                                name="options"
                                label="Options"
                                hideLabel={true}
                                render={({ field }) => {
                                    return (
                                        <ul
                                            className="list list-checkbox"
                                            style={{
                                                margin: '0px',
                                                padding: '0px',
                                                listStyleType: 'none',
                                                maxHeight: '30vh',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            {options.map((option, optionIndex) => {
                                                if (option.options) {
                                                    const allSelected = option.options.every(opt => form.values.options.find(o => o.value == opt.value));

                                                    return (
                                                        <li
                                                            key={optionIndex}
                                                            style={{
                                                                margin: '0px',
                                                                padding: '0px'
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={e => {
                                                                        handleGroupCheckChange(e, option.options, form, field);
                                                                    }}
                                                                    checked={allSelected}
                                                                    style={{
                                                                        marginRight: '0.5rem'
                                                                    }}
                                                                />
                                                                {option.label}
                                                                <ul style={{ listStyle: 'none', paddingTop: '6px' }}>
                                                                    {option.options.map((opt, optIndex) => {
                                                                        const foundItem = form.values.options.find(o => o.value == opt.value);
                                                                        let isChecked = false;

                                                                        if (foundItem) {
                                                                            isChecked = true;
                                                                        }

                                                                        return (
                                                                            <li key={optIndex}>
                                                                                <label
                                                                                    style={{
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                >
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        onChange={e => {
                                                                                            handleCheckChange(e, opt, form, field);
                                                                                        }}
                                                                                        checked={isChecked}
                                                                                        style={{
                                                                                            marginRight: '0.5rem'
                                                                                        }}
                                                                                        value={opt.value}
                                                                                    />
                                                                                    {opt.label}
                                                                                </label>
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            </label>
                                                        </li>
                                                    );
                                                } else {
                                                    const foundItem = form.values.options.find(opt => opt.value == option.value);
                                                    let isChecked = false;

                                                    if (foundItem) {
                                                        isChecked = true;
                                                    }

                                                    return (
                                                        <li
                                                            key={optionIndex}
                                                            style={{
                                                                margin: '0px',
                                                                padding: '0px'
                                                            }}
                                                        >
                                                            <label
                                                                style={{
                                                                    cursor: 'pointer'
                                                                }}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={e => {
                                                                        handleCheckChange(e, option, form, field);
                                                                    }}
                                                                    checked={isChecked}
                                                                    style={{
                                                                        marginRight: '0.5rem'
                                                                    }}
                                                                    value={option.value}
                                                                />
                                                                {option.label}
                                                            </label>
                                                        </li>
                                                    );
                                                }
                                            })}
                                        </ul>
                                    );
                                }}
                            />
                            {renderMenuButtons({ handleCancel, handleClear, form })}
                        </form>
                    );
                }}
            />
        </div>
    );
}

export default Checklist;
